(function () {
  'use strict';

  // Hover-intent opening for header nav dropdowns/mega-menus on desktop,
  // layered on top of Dawn's native click-to-toggle <details> behaviour.
  // Click and keyboard behaviour (and the mobile drawer) are untouched —
  // this only adds a mouseenter/mouseleave affordance at wide viewports.
  var desktopQuery = window.matchMedia('(min-width: 990px)');

  document.querySelectorAll('.header__inline-menu header-menu').forEach(function (menu) {
    var details = menu.querySelector('details');
    if (!details) return;

    var closeTimer;

    menu.addEventListener('mouseenter', function () {
      if (!desktopQuery.matches) return;
      window.clearTimeout(closeTimer);
      details.open = true;
    });

    menu.addEventListener('mouseleave', function () {
      if (!desktopQuery.matches) return;
      closeTimer = window.setTimeout(function () {
        details.open = false;
      }, 150);
    });
  });
})();
